function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCurrentLocationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.766 5.234a.8.8 0 01.195.812l-7.245 22.4a.8.8 0 01-1.511.033l-3.946-10.622a.2.2 0 00-.117-.117l-10.62-3.945a.8.8 0 01.032-1.511l22.4-7.245a.8.8 0 01.812.195z",
    fill: props.color
  }));
}

export default SvgIconCurrentLocationFilled;